import { render } from "./newMarque.vue?vue&type=template&id=19ec6364&scoped=true"
import script from "./newMarque.vue?vue&type=script&lang=js"
export * from "./newMarque.vue?vue&type=script&lang=js"

import "./newMarque.vue?vue&type=style&index=0&id=19ec6364&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ec6364"]])

export default __exports__